import store from '@/store';

export default {
  getBetName(betting, nameLabel = 'name') {
    const keynameLabels = {
      name: 'keyname',
      title: 'titleKeyName',
      typeValue: 'typeValueKeyName',
    };
    if (store.state.usePackageTranslations && betting?.[keynameLabels?.[nameLabel]]) {
      return store.getters.translations?.[betting[keynameLabels[nameLabel]]];
    }
    return betting?.[nameLabel] || '';
  },
  getOutcomeName(betting, outcomeIndex) {
    if (outcomeIndex !== null && outcomeIndex !== undefined) {
      if (store.state.usePackageTranslations && betting.outcomeKeyNames?.[outcomeIndex]) {
        return store.getters.translations?.[betting.outcomeKeyNames[outcomeIndex]];
      }
      return betting?.outcomes?.[outcomeIndex] || '';
    } else {
      const keyname = betting?.outcome?.titleKeyName;
      return keyname && store.state.usePackageTranslations
        ? store.getters.translations?.[keyname]
        : betting?.outcome?.title;
    }
  },
};
